import { BASE_URL } from '@features/env';
import { HTTP_DEFAULT_TIMEOUT } from '@features/shared/constants/http';

export const deleteListById = async (id: string): Promise<void> => {
  const response = await fetch(`${BASE_URL}/v1/lists/${id}`, {
    method: 'DELETE',
    credentials: 'include',
    signal: AbortSignal.timeout(HTTP_DEFAULT_TIMEOUT),
  });

  if (response.status === 401) {
    window.location.pathname = '/login';
    return Promise.reject(new Error('Unauthorized'));
  }

  if (!response.ok) {
    throw new Error('Erro ao deletar lista');
  }

  return;
};
